export const TRANSLATIONS_METRICS_NE = {
  header: {
    title: {
      default: 'global.metrics_and_reports',
      rf: 'rf.global.metrics_and_reports'
    },
    description: 'metrics.hero.description',
    goToReport: {
      default: 'metrics.go_to_reports.button',
      rf: 'metrics.rf.go_to_reports.button'
    }
  },
  timerSelector: {
    title: 'metrics.timer_selector.title',
    buttonThreeMonths: 'metrics.time_selector.button.3_months',
    buttonTwelveMonths: 'metrics.time_selector.button.12_months',
    lastThreeMonths: 'metrics.time_selector.3_months',
    lastTwelveMonths: 'metrics.time_selector.12_months'
  },
  comingSoonCard: {
    title: 'metrics.coming_soon.title',
    description: 'metrics.coming_soon.description'
  },
  tabs: {
    collaborators: 'global.collaborators.title',
    benefits: 'global.benefits',
    activities: 'global.activities',
    learning: 'global.learning',
    donations: 'global.donations',
    protection: 'global.protection',
    challenges: 'global.challenges_plural',
    otherMetrics: 'global.other_metrics.main'
  },
  benefits: {
    chartCard: {
      title: 'metrics.benefits.intention_use_card.title',
      label: 'metrics.benefits.intention_use_card.data_description',
      unitsName: 'metrics.benefits.intention_use_card.bubble_label'
    }
  },
  donations: {
    rankingCard: {
      trees: 'donation.global.trees.main',
      food: 'donation.global.food.main',
      water: 'donation.global.water.main',
      education: 'donation.global.education.main',
      other: 'donation.global.other_causes.main'
    },
    chartCard: {
      title: 'metrics.donations.bubble_chart.title',
      donations: 'metrics.donations.total_donations.main',
      totalCauses: 'metrics.donations.total_causes.main',
      bubbleLabel: 'metrics.donations.bubble_chart.bubble_label'
    }
  },
  protections: {
    types: {
      cancer: 'global.protection_cancer.title',
      dental: 'global.protection_dental.title',
      health: 'global.protection_health.title',
      life: 'global.protection_life.title',
      bike: 'global.protection_bike.title',
      assistance: 'global.protection_assistance.title',
      fraud: 'global.protection_fraud.title',
      pharmacy: 'global.protection_pharmacy.title',
      supplemental: 'global.protection_supplemental.title',
      pet: 'global.protection_pet.title'
    },
    titleWithoutInsurance: 'global.insured_employees.main',
    chartDescription: 'metrics.protection.bubble_chart.data_description',
    tooltip: 'metrics.protection.bubble_chart.tooltip',
    chartLabelWithInsurance: 'metrics.bubble_chart.selection.bubble_label',
    chartLabelWithoutInsurance: 'metrics.benefits.intention_use_card.bubble_label',
    labels: {
      totalEmployes: 'global.total_employees.main',
      insuredEmployes: 'global.insured_employees.main'
    },
    tooltipWithoutInsurance: {
      invited: 'metrics.collaborators_card.tooltip.invited_users',
      active: 'metrics.protection.insured_employees_chart.tooltip.insured_employees'
    },
    cards: {
      errorServiceTitle: 'global.service_error.title',
      errorServiceDescription: 'global.service_error.description',
      withoutInsuranceTitle: 'metrics.protection.card_container.fixed_insurance.title',
      withoutInsuranceDescription1: 'metrics.protection.insight_card.average_coverage',
      withoutInsuranceDescription2: 'metrics.protection.insight_card.team_interest',
      withInsuranceTitle: 'metrics.protection.card_container.dinamyc_insurance.title',
      withInsuranceDescription1: 'metrics.protection.insight_card.coverage_growth',
      withInsuranceDescription2: 'metrics.protection.insight_card.team_coverage_growth',
      insight: 'global.insight.month'
    },
    coverageGraph: {
      title: 'metrics.protection.coverage_progress.title',
      textBase: 'global.contract_coverage.main',
      textTotal: 'global.total_coverage.main',
      textBottom: 'global.contract_coverage.main',
      toolTipEmptyHover: 'metrics.protection.coverage_progress.empty_state.tooltip',
      toolTipHover: 'metrics.protection.coverage_progress.tooltip'
    }
  },
  emptyCard: {
    title: 'metrics.ranking_card.empty_state.title',
    description: 'metrics.ranking_card.empty_state.description'
  },
  challenges: {
    retry: 'csp.retry',
    error: {
      title: 'global.service_error.title',
      description: 'global.service_error.description'
    },
    summary: {
      title: 'csp.summary',
      activeChallenge: 'metrics.challenges.summary.active_challenges',
      totalParticipants: 'metrics.challenges.summary.total_participants',
      participationRate: 'metrics.challenges.summary.participation_rate',
      completionRate: 'metrics.challenges.summary.completion_rate',
      betterfliesDelivered: 'metrics.challenges.summary.betterflies_delivered',
      tooltip: 'metrics.challenges.summary.tooltip'
    },
    challengeType: {
      title: 'metrics.challenges.challenge_type.title'
    },
    ranking: {
      title: 'metrics.challenges.ranking.title',
      columns: {
        position: 'metrics.challenges.ranking.columns.position',
        collaborator: 'metrics.challenges.ranking.columns.collaborator',
        currentMonth: 'metrics.challenges.ranking.columns.current_month',
        previousMonth: 'metrics.challenges.ranking.columns.previous_month',
        variation: 'metrics.challenges.ranking.columns.variation'
      },
      types: {
        steps: 'global.steps',
        donations: 'global.donations',
        training: 'global.training',
        meditation: 'global.meditation'
      },
      new: 'metrics.challenges.ranking.new',
      noName: 'metrics.challenges.ranking.no_name',
      emptyState: {
        title: 'metrics.challenges.ranking.empty_state.title',
        description: 'metrics.challenges.ranking.empty_state.description'
      }
    },
    emptyPage: {
      title: 'metrics.challenges.empty_page.title',
      description: 'metrics.challenges.empty_page.description',
      button: 'challenges.button.create_challenge'
    },
    emptyPastMonth: {
      title: 'metrics.ranking_card.empty_state.title',
      description: 'metrics.ranking_card.empty_state.description'
    }
  },
  onboardingCard: {
    referenceInvited: 'metrics.collaborators_card.reference.invited',
    referenceInvitedTooltip: 'metrics.collaborators_card.tooltip.invited_users',
    referenceInvitedTooltipPlural: 'metrics.collaborators_card.tooltip.invited_users_plural',
    referenceActive: 'metrics.collaborators_card.reference.active',
    referenceActiveTooltip: 'metrics.collaborators_card.tooltip.active_users',
    referenceActiveTooltipPlural: 'metrics.collaborators_card.tooltip.active_users_plural',
    timelineTitle: 'metrics.collaborators_card.timeline.title',
    emptyState: {
      title: 'metrics.collaborators_card.empty_state.title',
      description: 'metrics.collaborators_card.empty_state.description',
      button: 'button.add_collaborators'
    },
    noActive: {
      title: 'metrics.collaborators_card.no_active_banner.title',
      description: 'metrics.collaborators_card.no_active_banner.description',
      button: 'metrics.collaborators_card.no_new_actives_banner.button'
    },
    noNewActive: {
      title: 'metrics.collaborators_card.no_new_actives_banner.title',
      description: 'metrics.collaborators_card.no_new_actives_banner.description',
      button: 'metrics.collaborators_card.no_new_actives_banner.button'
    }
  },
  rankingCard: {
    collaborators: {
      title: 'metrics.collaborators.ranking_card.title',
      valueText: ''
    },
    donations: {
      title: 'metrics.donations.ranking_card.title',
      valueText: ''
    },
    emptyState: {
      emptyStateTitle: 'metrics.ranking_card.empty_state.title',
      emptyStateDescription: 'metrics.ranking_card_betterflies.empty_state.description',
      noDataDescription: 'metrics.ranking_card.empty_state.description'
    },
    listLoading: 'metrics.ranking_card_betterflies.list_loading',
    listLoaded: 'metrics.ranking_card_betterflies.list_loaded'
  }
};

export const METRICS_ONBOARDING_CARD = {
  referenceInvited: 'metrics.collaborators_card.reference.invited',
  referenceActive: 'metrics.collaborators_card.reference.active'
};

export const METRICS_RANKING_CARD = {
  collaborators: {
    title: 'metrics.collaborators.ranking_card.title',
    valueText: ''
  },
  benefits: {
    title: 'metrics.benefits.ranking_card.title',
    valueText: ''
  },
  emptyState: {
    emptyStateTitle: 'metrics.ranking_card.empty_state.title',
    emptyStateDescription: 'metrics.ranking_card.empty_state.description'
  }
};
